import request from '@/utils/request';

//我的推广码信息
export function getMySpreadCode() {
  return request({
    url: '/api/my_tuiguang_info',
    method: 'post'
  })
}
//企业客户列表
export function getCustomerList_qy(data) {
  return request({
    url: '/api/com_kehu_list',
    method: 'post',
    data
  })
}
//个人客户列表
export function getCustomerList_gr(data) {
  return request({
    url: '/api/geren_kehu_list',
    method: 'post',
    data
  })
}